export default __webpack_public_path__ + "static/media/circle3.e46d80ec.png";